import { Link } from "react-router-dom";
import Logo from "../../../components/Logo";
import { AnimatePresence, LayoutGroup, delay, motion } from "framer-motion";
import BlogNavbar from "../components/BlogNavbar";
import BlogEntry from "../components/BlogEntry";
import { useEffect, useState } from "react";
import api from "../../../api";


const movieCardImage = require("../../../assets/icons/ldr.jpg")
const gameCardImage = require("../../../assets/icons/dnd.jpg")

const cardVariants = {
  initial: {
    border: 0
  },
  hover: {
    border: '15px solid rgb(204,164,156)',
    // backgroundColor: 'rgba(208,164,156,0.5)',
  }
}

const BlogHome = () => {

  const [recentPosts, setRecentPosts] = useState([]);

  useEffect(() => {
    const getRecentPosts = async () => {
      const response = await api.get("/post");
      setRecentPosts(response.data);
    }

    getRecentPosts();


  }, [])

  return (
    <div className="">
      <BlogNavbar />
      <div className="container-fluid blogHeroContainer">
        <div className="container">

          <div className="row ">
            <div className="col-lg-6 flex-column d-flex justify-content-center">
              <p className="blogHomeTitle">Book, Show & Game</p>

              <p className="blogHomeDesc">
                I'm utilizing this platform to record the experiences I encounter and the thoughts that arise from them.

              </p>

              <p className="blogHomeDesc">
                The purpose is to create a personal memorial capturing my past preferences and dislikes, allowing me to reflect on how I've changed and the valuable lessons I've acquired along the way.
              </p>
              <div className="blogHomeQuote">
                <small>We live only to discover beauty, all else if a form of waiting.</small>
                <small>- Kahlil Gibran</small>
              </div>
            </div>
            <div className="col-lg-6 d-flex">
              <div className="container-fluid">
                <div className="row">


                  <Link to={`/blog/show`} className="col-lg-6">
                    <div className="blogTypeCard" style={{ backgroundImage: `url(${movieCardImage})` }}>
                      <motion.div variants={cardVariants} initial="initial" whileHover="hover" className=" w-100 h-100 d-flex align-items-end">
                        <div className="p-3">

                          <p className="blogTypeTitle">
                            Shows
                          </p>
                        </div>


                      </motion.div>
                    </div>
                  </Link>


                  <Link to={`/blog/game`} className="col-lg-6">
                    <div className="blogTypeCard" style={{ backgroundImage: `url(${gameCardImage})` }}>
                      <motion.div variants={cardVariants} initial="initial" whileHover="hover" className=" w-100 h-100 d-flex align-items-end">
                        <div className="p-3">

                          <p className="blogTypeTitle">
                            Games
                          </p>
                        </div>


                      </motion.div>
                    </div>
                  </Link>


                  <Link to={`/blog/music`} className="col-lg-6">
                    <div className="blogTypeCard" style={{ backgroundImage: `url(${gameCardImage})` }}>
                      <motion.div variants={cardVariants} initial="initial" whileHover="hover" className=" w-100 h-100 d-flex align-items-end">
                        <div className="p-3">

                          <p className="blogTypeTitle">
                            Music
                          </p>
                        </div>


                      </motion.div>
                    </div>
                  </Link>


                  <Link to={`/blog/book`} className="col-lg-6">
                    <div className="blogTypeCard" style={{ backgroundImage: `url(${movieCardImage})` }}>
                      <motion.div variants={cardVariants} initial="initial" whileHover="hover" className=" w-100 h-100 d-flex align-items-end">
                        <div className="p-3">

                          <p className="blogTypeTitle">
                            Books
                          </p>
                        </div>


                      </motion.div>
                    </div>
                  </Link>

                </div>
              </div>

            </div>
          </div>


        </div>

      </div>

      <div className="my-3 blogHomeBody">

        <small>Recent Activity</small>
        {

          recentPosts.map((post, index) => {
 
            return (
              <div key={post.post_id}>
                <BlogEntry post_id={post.post_id} title={post.title} rating={post.post_rating} content={post.content} thumbnail={post.thumbnail} type={post.post_type} date={post.created_at} />
                {index !== recentPosts.length - 1 &&

                  <hr className="blogEntryHr" />
                }
              </div>
            )
          })

        }





      </div>

    </div>
  )
}

export default BlogHome;